import React from 'react';
import { Box } from 'vindi-ds-components';

function TwoColmunsFieldsRow({ gridTemplateColumns, children }) {
  return (
    <Box
      mb='2rem'
      style={{ gap: '3rem' }}
      display='grid'
      gridTemplateColumns={gridTemplateColumns}
    >{children}
    </Box>
  );
}

export default TwoColmunsFieldsRow;
